//#region src/lib/places-autocomplete.ts
const PLACES_AUTOCOMPLETE_SELECTOR = ".pac-container";
/** Keeps an overlay open when the press lands on a Google Places suggestion. */
const ignorePlacesAutocompletePointerDown = (handler) => (event) => {
	if (event.target instanceof Element && event.target.closest(PLACES_AUTOCOMPLETE_SELECTOR)) {
		event.preventDefault();
		return;
	}
	handler?.(event);
};
//#endregion
export { ignorePlacesAutocompletePointerDown };

//# sourceMappingURL=places-autocomplete.js.map